import { ArrowRightIcon } from '@koaly/koaly-ui-icons';
import { rem } from '@koaly/mixins';
import { createElement } from 'react';
import styled from 'styled-components';
import { useLinkWrapper } from '../../hooks/useLinkWrapper.js';
import { Dot } from '../Dot/Dot.js';
import { DrawerContainer } from '../Drawer/DrawerContainer.js';
import { DrawerHeader } from '../Drawer/DrawerHeader.js';
import { Navigation } from '../Navigation/Navigation.js';
import { NavigationItem } from '../Navigation/NavigationItem.js';

const StyledMobileNavigation = styled(Navigation) `
  a {
    font-size: ${rem(26)};
    line-height: 1.2;
  }
`;
const MobileDrawerNavigation = ({ links, variant, appearance }) => {
    const linkWrap = useLinkWrapper();
    return (createElement(DrawerContainer, null,
        createElement(DrawerHeader, { spaceAfter: 20 }),
        createElement(StyledMobileNavigation, { spacing: 10, direction: "vertical", align: "left" }, links &&
            links.map((item, i) => linkWrap(createElement(NavigationItem, { appearance: appearance, variant: variant, href: item.href, key: i + '-link-top-bar' },
                item.label,
                " ",
                createElement(Dot, { size: 10, variant: variant === 'primary' || !variant ? 'secondary' : 'primary' },
                    createElement(ArrowRightIcon, null))))))));
};

export { MobileDrawerNavigation };
//# sourceMappingURL=MobileDrawerNavigation.js.map
